import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { VariantCategory } from "../../types/modules/variantCategory.type";

export const useVariantCategories = () => {
  return useQuery({
    queryKey: ["variant-categories"],
    queryFn: () => fetcher<VariantCategory[]>(`variant-category`),
  });
};
